export const SESSION_STORAGE_BASE_SEARCH_SAVED_FIELDS = "search-saved-fields";
